export default {
  // Hero
  'hero.badge': 'Manufacturing Alliance',
  'hero.title': '대규모 공장들이 모인 제조 연합',
  'hero.imageAlt': '제조 연합 공장 단지',
  'hero.subtitle':
    '4개의 전문적이고 고도 자동화된 생산시설이 협력하여 글로벌 브랜드에 화장품 포장을 직접 공급합니다.',
  'hero.message':
    '우리는 불특정 공급업체를 연결하는 무역회사가 아닙니다. 실제 대규모·고도 자동화된 공장들이 모여 만든 제조 연합(Manufacturing Alliance)입니다. 4개 전문 생산시설의 역량을 결합하여, 신뢰할 수 있는 품질, 안정적인 대량생산, 통합 공급, 그리고 경쟁력 있는 글로벌 가격을 제공합니다.',
  'hero.cta.quote': '견적 요청',
  'hero.cta.contact': '상담 문의',
  'hero.scroll': '공장 둘러보기',

  // Intro
  'intro.label': '공급업체 네트워크',
  'intro.title': '새롭게 정의된 공급업체 네트워크',
  'intro.subtitle': '제조 연합이 어떻게 전문 공장들을 하나의 통합 공급망으로 결합하는지 알아보세요.',
  'intro.networkTitle': '전문 공장들의 통합 연합',
  'intro.networkDesc':
    '검증되지 않은 개별 공급업체에 흩어져 소싱하는 대신, 저희 제조 연합은 4개의 전문 생산시설을 하나의 조율된 운영 체계로 결합합니다. 각 공장은 유리·튜브·플라스틱·통합 포장 등 가장 잘하는 분야에 집중하면서, 동일한 품질·자동화·신뢰성 기준을 공유합니다.',
  'intro.stat.factories': '4',
  'intro.stat.factories.label': '전문 공장',
  'intro.stat.automation': '4세대',
  'intro.stat.automation.label': '자동화 생산',
  'intro.stat.integrated': '1',
  'intro.stat.integrated.label': '통합 공급망',

  // Factories
  'factories.label': '생산시설',
  'factories.title': '4개의 공장을 만나보세요',
  'factories.subtitle':
    '각 시설은 4세대 자동화 설비와 전담 품질관리를 갖춘 실제 대규모 생산기지입니다.',

  // Factory common labels
  'factory.label': '공장',
  'factory.introduction': '공장 소개',
  'factory.products': '주요 생산품목',
  'factory.technology': '전문 생산기술',
  'factory.automation': '자동화 설비 및 생산능력',
  'factory.capacity': '연간 생산능력',
  'factory.established': '설립연도',
  'factory.qc': '품질관리',

  // Gallery labels
  'gallery.title': '갤러리',
  'gallery.scrollLeft': '왼쪽으로 스크롤',
  'gallery.scrollRight': '오른쪽으로 스크롤',
  'gallery.overview': '공장 전경',
  'gallery.productionLine': '생산라인',
  'gallery.automation': '자동화 설비',
  'gallery.qc': '품질관리',
  'gallery.warehouse': '창고',
  'gallery.rawMaterial': '원자재',
  'gallery.finished': '완제품',
  'gallery.printing': '인쇄',
  'gallery.molding': '사출 성형',
  'gallery.assembly': '조립',
  'gallery.decoration': '장식',

  // Placeholders
  'placeholder.tbd': '[입력 예정]',
  'placeholder.pending': '정보 입력 예정',

  // Glass Bottles Factory
  'factory.glass.name': 'Cristallo Glassworks Co., Ltd.',
  'factory.glass.tagline': '프리미엄 유리 용기 전문',
  'factory.glass.history':
    '2003년 광저우 산업단지에서 소규모 용해로 공방으로 시작한 Cristallo Glassworks는 180,000㎡ 규모의 수출형 생산기지로 성장했습니다. 현재 12개의 자동화 유리 성형·서냉 라인을 운영하며, 유럽·북미·일본의 40여 개 화장품 브랜드에 공급하고 있습니다.',
  'factory.glass.established': '2003년',
  'factory.glass.capacity': '연간 1억 2천만 개',
  'factory.glass.product1': '화장품 유리병',
  'factory.glass.product2': '유리 드로퍼 병',
  'factory.glass.product3': '유리 크림 단지',
  'factory.glass.product4': '향수 유리병',
  'factory.glass.spec1': '정밀 유리 성형',
  'factory.glass.spec2': '컬러 스프레이 & 프로스팅',
  'factory.glass.spec3': '실크스크린 & 핫스탬핑',
  'factory.glass.spec4': '고투명 유리 성형',
  'factory.glass.automation':
    '4세대 자동화 유리 성형·서냉·검사 라인을 갖추어 대량 생산과 일관된 품질을 실현합니다.',
  'factory.glass.qc':
    '치수 정확도, 투명도, 내압성, 표면 마감까지 다단계 검사와 완전한 이력 추적을 수행합니다.',

  // Cosmetic Tubes Factory
  'factory.tubes.name': 'FlexoTech Tube Industries',
  'factory.tubes.tagline': '라미네이트 & 스퀴즈 튜브 전문',
  'factory.tubes.history':
    '1998년 설립된 FlexoTech는 이 지역에서 ABL 튜브 라미네이션 기술을 개척했습니다. 3개 생산 캠퍼스와 28개 압출·인쇄·충진 라인을 갖추고, 매년 3억 개 이상의 튜브를 글로벌 뷰티·퍼스널케어 브랜드에 공급합니다.',
  'factory.tubes.established': '1998년',
  'factory.tubes.capacity': '연간 3억 개',
  'factory.tubes.product1': '화장품 라미네이트 튜브',
  'factory.tubes.product2': '플라스틱 스퀴즈 튜브',
  'factory.tubes.product3': 'ABL / PBL 튜브',
  'factory.tubes.product4': '에어리스 튜브',
  'factory.tubes.spec1': '튜브 압출 & 라미네이션',
  'factory.tubes.spec2': '튜브 충진 & 실링',
  'factory.tubes.spec3': '다색 옵셋 인쇄',
  'factory.tubes.spec4': '튜브 숄더 & 캡 성형',
  'factory.tubes.automation':
    '고속 자동화 압출·다색 인쇄·충진·실링 라인으로 안정적인 대량 생산을 보장합니다.',
  'factory.tubes.qc':
    '인쇄 품질, 실링 무결성, 소재 일관성을 표준화된 QC 프로토콜로 검사합니다.',

  // Plastic Bottles Factory
  'factory.plastic.name': 'PolyForm Packaging Co., Ltd.',
  'factory.plastic.tagline': 'PET / PP 병 전문',
  'factory.plastic.history':
    '2006년 설립된 PolyForm은 PET, PP, PETG 병을 전문으로 생산합니다. 완전 자동화된 블로우 성형 공장을 24시간 가동하며 로봇 소팅·검사 시스템을 통해 연간 5억 개의 병을 30여 개국 고객에게 공급합니다.',
  'factory.plastic.established': '2006년',
  'factory.plastic.capacity': '연간 5억 개',
  'factory.plastic.product1': 'PET 화장품 병',
  'factory.plastic.product2': 'PP / PETG 병',
  'factory.plastic.product3': '에어리스 펌프 병',
  'factory.plastic.product4': '로션 & 스프레이 병',
  'factory.plastic.spec1': '인젝션 스트레치 블로우 성형',
  'factory.plastic.spec2': '압출 블로우 성형',
  'factory.plastic.spec3': '사출 성형',
  'factory.plastic.spec4': '표면 장식 & 코팅',
  'factory.plastic.automation':
    '완전 자동화된 블로우 성형과 로봇 소팅 시스템으로 고속·정밀 대량 생산을 제공합니다.',
  'factory.plastic.qc':
    '모든 생산 배치에 대한 치수·낙하·누수 테스트로 신뢰할 수 있는 무결점 제품을 보장합니다.',

  // Cosmetic Packaging Manufacturer
  'factory.packaging.name': 'CosmePack Manufacturing Group',
  'factory.packaging.tagline': '통합 포장 솔루션',
  'factory.packaging.history':
    '1995년부터 CosmePack은 장식, 조립, 턴키 포장을 하나의 공정으로 통합해 왔습니다. 저희 연합의 대표 시설로서, 원자재 소싱부터 시장 출시가 가능한 완성형 포장까지 전체 OEM/ODM 프로그램을 관리합니다.',
  'factory.packaging.established': '1995년',
  'factory.packaging.capacity': '턴키 통합 공급',
  'factory.packaging.product1': '화장품 포장 세트',
  'factory.packaging.product2': '캡, 펌프 & 액세서리',
  'factory.packaging.product3': '컴팩트 & 쿠션 케이스',
  'factory.packaging.product4': '맞춤 OEM 포장',
  'factory.packaging.spec1': '풀 포장 조립',
  'factory.packaging.spec2': '다공정 장식',
  'factory.packaging.spec3': 'OEM / ODM 솔루션',
  'factory.packaging.spec4': '턴키 포장 공급',
  'factory.packaging.automation':
    '로봇 핸들링을 갖춘 통합 자동화 조립·장식 라인으로 유연한 대량 포장 생산이 가능합니다.',
  'factory.packaging.qc':
    '원자재 입고부터 완제품까지, 색상 매칭 및 기능 테스트를 포함한 엔드투엔드 품질 관리를 수행합니다.',

  // Integrated supply
  'integrated.label': '우리가 가치를 제공하는 이유',
  'integrated.title': '통합 공급, 비교할 수 없는 가치',
  'integrated.subtitle':
    '4개의 전문 공장을 하나의 연합으로 결합하여, 분산 소싱으로는 얻을 수 없는 가치를 제공합니다.',
  'integrated.quality.title': '신뢰할 수 있는 품질',
  'integrated.quality.desc':
    '4개 시설 전반의 표준화된 품질관리로 모든 주문에 일관되고 신뢰할 수 있는 결과물을 보장합니다.',
  'integrated.stability.title': '안정적인 대량생산',
  'integrated.stability.desc':
    '4세대 자동화 라인으로 대량 주문에 필요한 생산량과 일관성을 제공합니다.',
  'integrated.supply.title': '통합 공급',
  'integrated.supply.desc':
    '유리, 튜브, 플라스틱 포장을 하나의 협력 연합에서 통합 소싱할 수 있습니다.',
  'integrated.price.title': '경쟁력 있는 글로벌 가격',
  'integrated.price.desc':
    '중간 유통 없이 공장 직거래로 비용을 투명하고 글로벌 수준으로 경쟁력 있게 유지합니다.',

  // Quality control
  'qc.label': '품질 보증',
  'qc.title': '품질관리 및 검사 시스템',
  'qc.subtitle': '모든 공장이 동일하고 엄격한 다단계 품질 보증 프로세스를 따릅니다.',
  'qc.item1': '원자재 입고 검사',
  'qc.item2': '공정 중 치수 및 외관 검사',
  'qc.item3': '내압 및 누수 테스트',
  'qc.item4': '인쇄 및 색상 매칭 검증',
  'qc.item5': '기능 및 조립 테스트',
  'qc.item6': '선적 전 최종 검사',

  // CTA
  'cta.label': '소싱 시작',
  'cta.title': '신뢰할 수 있는 소싱을 시작할 준비가 되셨나요?',
  'cta.subtitle': '필요한 포장 사양을 알려주시면 제조 연합에서 직접 견적을 받아보실 수 있습니다.',
  'cta.quote': '견적 요청',
  'cta.contact': '상담 문의',
};